import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportsRoutingModule } from './reports-routing.module';
import { ReportListComponent } from './components/report-list/report-list.component';
import { ReportsContainerComponent } from './container/reports-container/reports-container.component';


@NgModule({
  declarations: [ReportListComponent, ReportsContainerComponent],
  imports: [
    CommonModule,
    ReportsRoutingModule
  ]
})
export class ReportsModule { }
